let styleSelects = require('../styled-select/styled-select');
require('./tutorials.less');

$(function() {
    styleSelects.styleSelects($('.js-styled-select'));

    /**
     * Обработка Ajax перезагрузки компонента
     * @param element
     */

    var ajaxComponent = function(element) {
        window.mxLoader = window.mxLoader || undefined;

        var $this = $(element);
        var $container = $this.closest('.js-ajax-component');

        if ($container.length === 1) {
            var ajax = $container.data('ajax');
            var url = ajax['URL'] ? ajax['URL'] : null;
            var parameters = ajax['PARAMETERS'] ? ajax['PARAMETERS'] : null;
            var data = {};

            if (!url) {
                return;
            }

            if ($this.is('input') || $this.is('select')) {
                // Перезагрузку вызвал инпут
                data[element.name] = element.value;
            } else if ($this.hasClass('pagination__item')) {
                // Перезагрузку вызвал элемент постраничной навигации
                if ($this.hasClass('pagination__item--current')) {
                    return;
                }

                var href = $this.attr('href');
                var matches = href && href.match ? href.match(/page=([\d]+)/) : [];

                data['page'] = matches ? parseInt(matches[1]) | 0 || 1 : 1;
            }

            var time = new Date().getTime() + 500;
            $('body, html').animate({ scrollTop: $container.offset().top - 15 }, 400);
            window.mxLoader && window.mxLoader.show();

            $.ajax({
                url: url + '?' + $.param(parameters),
                data: data,
                type: 'get',
                success: function(result) {
                    if (result && result.html) {
                        time = time - new Date().getTime();
                        time = time > 0 ? time : 0;

                        var $block, $select;
                        var $html = $(result.html);
                        $html.each(function() {
                            $block = $(this);
                            if ($block.hasClass('js-ajax-component')) {
                                var ajax = $block.data('ajax');
                                var get = ajax['GET'] ? $.param(ajax['GET']) : null;
                                var parameters = ajax['PARAMETERS'] ? ajax['PARAMETERS'] : null;

                                // Стилизация селектов
                                $select = $('.js-styled-select', $block);
                                $select && styleSelects.styleSelects($select);

                                // Установка нового адреса страницы
                                if (parameters && parameters['SET_URL'] !== 'N') {
                                    history &&
                                        history.pushState &&
                                        history.pushState(null, '', get ? '?' + get : window.location.pathname);
                                }

                                return false;
                            }
                        });

                        setTimeout(function() {
                            $container.replaceWith($html);
                            window.mxLoader && window.mxLoader.hide();
                        }, time);
                    }
                }
            });
        }
    };

    // Обработка при изменении значения фильтра или количества элементов
    $(document).on('change', '.js-ajax-component input, .js-ajax-component select', function() {
        ajaxComponent(this);
    });

    // Обработка при клике на элемент постраничной навигации
    $(document).on('click', '.js-ajax-component .pagination__item', function(event) {
        event.preventDefault();
        ajaxComponent(this);
    });
});



// WEBPACK FOOTER //
// ./blocks/tutorials/tutorials.js